export default "__VITE_ASSET__BvQF9bPw__"